import clsx from 'clsx';
import { Typography } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import ProductWizardState from '../../model/ProductWizardState';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import useStyles from './LabelWithTextRiskValue.style';

  const LabelWithTextRiskValue: FunctionComponent<{
    labelText?: string;
    riskLabelValue: number;
    size?: 'normal' | 'small',
    className?: string;
    htmlFor?: string;
  }> = ({labelText= '', riskLabelValue, size='normal', className, htmlFor}) => {
    const c = useStyles({size});
    const [t] = useTranslation('choose-risk-level');
    const risksLength = useSelector((state: ProductWizardState) => state.apiState.risks.length);

    return (
      <label htmlFor={htmlFor} aria-label={t('risk-label', {riskLevel: labelText?.toLowerCase(), riskValue: riskLabelValue, risksLength: risksLength})}>
        <Typography data-testid='risk' variant="body2" className={clsx(c.riskValueText, className)}>
          {labelText} <span className={c.labelValueWrapper}>(<span className={c.labelValue}>{riskLabelValue}</span>/{risksLength})</span>
        </Typography>
      </label>
    );
  };

export default LabelWithTextRiskValue;
